import React from 'react'

const CreateTask = () => {
    return <div>Create Task</div>
}

export default CreateTask
